import TableComponent from '../../Common/Charts/TableCharts';
import { number } from '../../Common/Util/number';
import { useEpidemiologyChartsDataContext } from './hooks/useEpidemiologyChartsDataContext';
import { useSanitizeData } from '../Common/hooks/useSanitizeData';

export const ByCidChapterTable = () => {
    const { chartData } = useEpidemiologyChartsDataContext();

    const tableColumns = [
        {
            key: 'capitulo',
            header: 'Capítulo CID',
            headerStyle: { fontWeight: '700' },
            cellStyle: { fontWeight: '400' }
        },
        {
            key: 'total',
            header: 'Total',
            headerStyle: { fontWeight: '700', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'pct',
            header: 'Percentual (%)',
            headerStyle: { fontWeight: '700', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => `${number.formatToBRNumber(value)}%`
        }
    ];

    const rawData = chartData?.epidemiologyByCidChapter || [];

    const sanitizedData = useSanitizeData(rawData);

    return (
        <TableComponent
            className="no-spacing-table"
            data={sanitizedData}
            columns={tableColumns}
            title="Distribuição por Capítulo CID"
            formatNumber={number.formatToBRNumber}
        />
    );
};